import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/fonts/fonts.css";
import "./assets/styles/index.css";
import "./assets/styles/responsive.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import './i18n/i18n';
import { GoogleOAuthProvider } from "@react-oauth/google";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <GoogleOAuthProvider clientId="245996360435-0ldggkisqnte4hkj5vhgtirho3vq2pq7.apps.googleusercontent.com">
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
